import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const UnitKeysRedux = createActions({},
  {
    prefix: 'UNIT_KEYS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = UnitKeysRedux
export const UnitKeysTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

export const reducer = createReducer(INITIAL_STATE, {},
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/UnitKeysRedux.js